const t = {
  review: "{reviewDomain}/{ws_code}",
  review_take: "{reviewDomain}/{ws_code}?id={take_id}",
  review_scene: "{reviewDomain}/{ws_code}?id={take_id}&scene_id={scene_id}&tab=iteration",
  review_rendition: "{reviewDomain}/{ws_code}?id={take_id}&scene_id={scene_id}&rendition_id={rendition_id}",
  review_frame: "{reviewDomain}/{ws_code}?id={take_id}&scene_id={scene_id}&rendition_id={rendition_id}&tab=comment&refresh_marker=true#type=frame&data={frame}",
  review_rendition_comment: "{reviewDomain}/{ws_code}?scene_id={scene_id}&rendition_id={rendition_id}&comment_id={comment_id}",
  review_comment: "{reviewDomain}/{ws_code}?id={take_id}&scene_id={scene_id}&comment_id={comment_id}",
  scene_hub: "{baseDomain}/{ws_code}/{scene_id}?o=st",
  hub_rendition: "{baseDomain}/{ws_code}/{scene_id}?o=st&renditionId={rendition_id}",
  hub_comment: "{baseDomain}/{ws_code}/{scene_id}?o=st&comment_id={comment_id}",
  people_insight: "{baseDomain}/{ws_code}/{user_id}?o=pt",
  people_detail: "{baseDomain}/{ws_code}/ws/ppl/{display_name}-${user_id}",
  project: "{baseDomain}/{ws_code}/pl/dir/{entity_id}",
  woohoo: "{baseDomain}/{ws_code}/pl/woo/rpt/{woohoo_id}",
  update: "{baseDomain}/{ws_code}/pl/au?id={entity_id}",
  core: "{baseDomain}/{ws_code}",
  project_focusMode: "{baseDomain}/{ws_code}/pl/dir/{parent_id}?f={entity_id}"
  /* project_focusMode */
}, a = ({ type: o, config: s }) => {
  const i = [];
  try {
    const e = t[o];
    if (!e)
      throw new Error(`Link template for link type "${o}" not found`);
    const n = e.replace(/{(.*?)}/g, (_, r) => {
      const d = s[String(r)];
      if (d !== void 0) return d;
      i.push(r);
    });
    return i.length > 0 ? {
      url: n,
      hasError: !0,
      error: `Missing required keys: ${i.join(", ")}`,
      missingKeys: i
    } : { url: n, hasError: !1, error: void 0 };
  } catch (e) {
    return console.error("Link Creator ERROR at:", e), {
      url: "",
      hasError: !0,
      error: e instanceof Error ? e.message : `Missing required keys: ${i.join(", ")}`
    };
  }
};
export {
  a as c
};
